import { useSelector } from '@/redux/helper';
import { selectHasTzPlusFeature } from '@/redux/selectors/users';

/**
 * The React twin of `hasTzPlusFeature` (config/tzPlus/feature.ts), for components — the registry's
 * gate is a pure function and cannot call a hook. Both answer from the same entitlement, so the
 * tour and its mobile message cannot disagree about who is eligible.
 *
 * Lives here rather than in feature.ts so the registry never imports the selectors module.
 */
const useHasTzPlusFeature = (): boolean => useSelector(selectHasTzPlusFeature);

export default useHasTzPlusFeature;
